import Vue from 'vue'
import Router from 'vue-router'

import AppView from '@/components/app-view'
import Home from '@/pages/home'

Vue.use(Router)

const page = name => () => import('@/pages/' + name)

export default new Router({
  //mode: 'history',
  routes: [
    {path: '/', name: 'login', component: page('login')},
    {
      path: '',
      component: AppView,
      children: [
        {path: '/home', name: 'home', component: Home, meta: {title: '控制面板'}},
        // 工作流
        {path: '/workTai', name: '工作台', component: page('workTai'), meta: {title: '工作台'}},
        {path: '/openProcess', name: '开启流程', component: page('openProcess'), meta: {title: '开启流程'}},
        {path: '/editForm', name: '编辑表单', meta: {title: '编辑表单'}, component: page('editForm')},
        {path: '/apply', name: '申请流程', meta: {title: '申请流程'}, component: page('apply')},
        {path: '/tableList', name: '我的工作', meta: {title: '我的工作'}, component: page('tableList')},
        {path: '/fileFolder', name: '公共文件柜', meta: {title: '公共文件柜'}, component: page('fileFolder')},
        {path: '/fileFolderSet', name: '文件柜设置', meta: {title: '文件柜设置'}, component: page('fileFolderSet')},
        {path: '/setProcess', name: '审批流程', meta: {title: '审批流程'}, component: page('setProcess')},
        {path: '/todo', name: '待办事宜', meta: {title: '待办事宜'}, component: page('todo')},
        {path: '/completeTodo', name: '已办事宜', meta: {title: '已办事宜'}, component: page('completeTodo')},
        {path: '/historyProcess', name: '相关事宜', meta: {title: '相关事宜'}, component: page('historyProcess')},
        {path: '/todoDetail', name: '流程详情', meta: {title: '流程详情'}, component: page('todoDetail')},
        // 交流园地
        {path: '/exchange', name: '交流园地', meta: {title: '交流园地'}, component: page('exchange')},
        {path: '/writeArticle', name: '写文章', meta: {title: '写文章'}, component: page('exchange/writeArticle')},
        // 个人事务
        {path: '/schedule', name: '日程安排', meta: {title: '日程安排'}, component: page('schedule')},
        {path: '/schedule/findAll', name: '全部日程', meta: {title: '全部日程'}, component: page('schedule/findAll')},
        {
          path: '/mailBox', 
          name: '邮箱管理', 
          meta: {title: '邮箱管理'}, 
          component: page('mailBox'),
          children: [
            {path: '/mailBox', name: '我的邮箱', meta: {title: '我的邮箱'}, component: page('mailBox/components/home')},
            {path: '/mailBox/Inbox', name: '收件箱', meta: {title: '收件箱'}, component: page('mailBox/components/Inbox')},
            {path: '/mailBox/sendBox', name: '已发送', meta: {title: '已发送'}, component: page('mailBox/components/sendBox')},
            {path: '/mailBox/recycleBox', name: '回收站', meta: {title: '回收站'}, component: page('mailBox/components/recycleBox')},
            {path: '/mailBox/draftBox', name: '草稿箱', meta: {title: '草稿箱'}, component: page('mailBox/components/draftBox')},
            {path: '/mailBox/writeLetters', name: '写信', meta: {title: '写信'}, component: page('mailBox/components/writeLetters')},
            {path: '/mailBox/sendSuccess', name: '发送成功', meta: {title: '发送成功'}, component: page('mailBox/components/sendSuccess')}            
          ]
        },
        {path: '/unReadBox', name: '未读邮件', meta: {title: '未读邮件'}, component: page('mailBox/components/unReadBox')},
        {path: '/details', name: '邮件详情', meta: {title: '邮件详情'}, component: page('mailBox/components/details')},
        {path: '/messageManagement', name: '消息管理', meta: {title: '消息管理'}, component: page('messageManagement')},
        {path: '/kaoqinPerson/kaoqinjl', name: '个人考勤记录', meta: {title: '个人考勤记录'}, component: page('kaoqinPerson/kaoqinjl')},
        {path: '/kaoqinPerson/kaoqintj', name: '个人考勤', meta: {title: '个人考勤'}, component: page('kaoqinPerson/kaoqintj')},
        {path: '/gongZuorz', name: '工作日志', meta: {title: '工作日志'}, component: page('gongZuorz')},
        {path: '/writeLog', name: '写日志', meta: {title: '写日志'}, component: page('gongZuorz/writeLog')},
        {path: '/fileFolderPerson', name: '个人文件柜', meta: {title: '个人文件柜'}, component: page('fileFolderPerson')},
        {path: '/addressBook', name: '通讯薄', meta: {title: '通讯簿'}, component: page('addressBook')},
        {path: '/addressBook/roleManage', name: '角色管理', meta: {title: '角色管理'}, component: page('addressBook/roleManage')},
        {path: '/aboutMe', name: '关于我', meta: {title: '关于我'}, component: page('aboutMe')},
        // 行政办公模块
        {path: '/newsManagement', name: '新闻管理', meta: {title: '新闻管理'}, component: page('newsManagement')},
        {path: '/newsDetails', name: '新闻详情', meta: {title: '新闻详情'}, component: page('newsManagement/components/newsDetails')},
        {path: '/createNews', name: '新闻编辑', meta: {title: '新闻编辑'}, component: page('newsManagement/components/createNews')},
        {path: '/noticeManagement', name: '公告管理', meta: {title: '公告管理'}, component: page('noticeManagement')},
        {path: '/noticeDetails', name: '公告详情', meta: {title: '公告详情'}, component: page('noticeManagement/components/noticeDetails')},
        {path: '/createNotice', name: '公告编辑', meta: {title: '公告编辑'}, component: page('noticeManagement/components/createNotice')},
        {path: '/voteManagement', name: '投票管理', meta: {title: '投票管理'}, component: page('voteManagement')},
        {path: '/voteManagement/voteDetail', name: '投票详情', meta: {title: '投票详情'}, component: page('voteManagement/voteDetail')},
        {path: '/workPlanManagement', name: '工作计划管理', meta: {title: '工作计划管理'}, component: page('workPlanManagement')},
        {path: '/createWorkPlan', name: '新建工作计划', meta: {title: '新建工作计划'}, component: page('workPlanManagement/createWorkPlan')},
        {path: '/workPlanDetail', name: '计划详情', meta: {title: '计划详情'}, component: page('workPlanManagement/workPlanDetail')},
        {
          path: '/officeManagement', 
          name: '办公用品管理', 
          meta: {title: '办公用品管理'}, 
          component: page('officeManagement'),
          children: [
            {path: '/officeManagement', name: '用品库管理', meta: {title: '用品库管理'}, component: page('officeManagement/components/ypkManage')},
            {path: '/officeManagement/wplbManage', name: '物品类别管理', meta: {title: '物品类别管理'}, component: page('officeManagement/components/wplbManage')},
            {path: '/officeManagement/ypxxManage', name: '用品信息管理', meta: {title: '用品信息管理'}, component: page('officeManagement/components/ypxxManage')},
            {path: '/officeManagement/bgypRecord', name: '库存操作记录', meta: {title: '库存操作记录'}, component: page('officeManagement/components/bgypRecord')},
          ]
        },
        {
          path: '/meetingManagement', 
          name: '会议管理', 
          meta: {title: '会议管理'}, 
          component: page('meetingManagement'),
          children: [
            {path: '/meetingManagement', name: '会议室管理', meta: {title: '会议室管理'}, component: page('meetingManagement/components/meetRoomManage')},
            {path: '/meetingManagement/hysbManage', name: '设备管理', meta: {title: '设备管理'}, component: page('meetingManagement/components/hysbManage')},
            {path: '/meetingManagement/meetApply', name: '会议申请', meta: {title: '会议申请'}, component: page('meetingManagement/components/meetApply')}
          ]
        },
        {
          path: '/carManagement', 
          name: '车辆使用管理', 
          meta: {title: '车辆使用管理'}, 
          component: page('carManagement'),
          children: [
            {path: '/carManagement', name: '车辆类型管理', meta: {title: '车辆类型管理'}, component: page('carManagement/components/useCarType')},
            {path: '/carManagement/messageCar', name: '车辆信息管理', meta: {title: '车辆信息管理'}, component: page('carManagement/components/messageCar')},
            {path: '/carManagement/useCarRecord', name: '车辆使用记录', meta: {title: '车辆使用记录'}, component: page('carManagement/components/useCarRecord')},            
            {path: '/carManagement/weihuCar', name: '车辆维护记录', meta: {title: '车辆维护记录'}, component: page('carManagement/components/weihuCar')},            
          ]
        },
        // 档案管理
        {path: '/juankuManagement', name: '案卷管理', meta: {title: '案卷管理'}, component: page('juankuManagement')},
        // 考勤模块
        {path: '/kaoqinzu', name: '考勤组管理', meta: {title: '考勤组管理'}, component: page('kaoqinManagement/kaoqinzu')},
        {path: '/kaoqinjl', name: '考勤记录', meta: {title: '考勤记录'}, component: page('kaoqinManagement/kaoqinjl')},
        {path: '/kaoqintj', name: '考勤统计', meta: {title: '考勤统计'}, component: page('kaoqinManagement/kaoqintj')},
        {path: '/kaoqinDetail', name: '考勤结果', meta: {title: '考勤结果'}, component: page('kaoqinManagement/kaoqinDetail')},
        {path: '/jiaqiSet', name: '假期管理', meta: {title: '假期管理'}, component: page('kaoqinManagement/jiaqiSet')},
        {path: '/jiaqiYe', name: '假期余额汇总', meta: {title: '假期余额汇总'}, component: page('kaoqinManagement/jiaqiYe')},
        {path: '/jiaqiPerson', name: '假期使用记录', meta: {title: '假期使用记录'}, component: page('kaoqinManagement/jiaqiPerson')},
        // 人力资源模块
        {path: '/jiangChengManagement', name: '奖惩管理', meta: {title: '奖惩管理'}, component: page('jiangChengManagement')},
        {path: '/liZhiManagement', name: '离职管理', meta: {title: '离职管理'}, component: page('liZhiManagement')},
        {path: '/yuanGongghManagement', name: '员工关怀管理', meta: {title: '员工关怀管理'}, component: page('yuanGongghManagement')},
        {
          path: '/renShidaManagement', 
          name: '人事档案', 
          meta: {title: '人事档案'}, 
          component: page('renShidaManagement'),
          children: [
            {path: '/renShidaManagement', name: '档案信息', meta: {title: '档案信息'}, component: page('renShidaManagement/components/danganManage')},
            {path: '/renShidaManagement/hetongManage', name: '合同管理', meta: {title: '合同管理'}, component: page('renShidaManagement/components/hetongManage')},
            {path: '/renShidaManagement/zhengzhaoManage', name: '证照管理', meta: {title: '证照管理'}, component: page('renShidaManagement/components/zhengzhaoManage')},
            {path: '/renShidaManagement/xuexiManage', name: '学习经历', meta: {title: '学习经历'}, component: page('renShidaManagement/components/xuexiManage')},
            {path: '/renShidaManagement/workManage', name: '工作经历', meta: {title: '工作经历'}, component: page('renShidaManagement/components/workManage')},
            {path: '/renShidaManagement/socialManage', name: '社会关系', meta: {title: '社会关系'}, component: page('renShidaManagement/components/socialManage')},
            {path: '/renShidaManagement/zhichengManage', name: '职称评定', meta: {title: '职称评定'}, component: page('renShidaManagement/components/zhichengManage')},          
          ]
        },
        {
          path: '/zhaoPinManagement', 
          name: '招聘管理', meta: {title: '招聘管理'}, 
          component: page('zhaoPinManagement'),
          children: [
            {path: '/zhaoPinManagement', name: '招聘计划', meta: {title: '招聘计划'}, component: page('zhaoPinManagement/zhaoPinjh')},
            {path: '/zhaoPinManagement/zhaoPinxq', name: '招聘需求', meta: {title: '招聘需求'}, component: page('zhaoPinManagement/zhaoPinxq')},
            {path: '/zhaoPinManagement/zhaoPinsp', name: '招聘审批', meta: {title: '招聘审批'}, component: page('zhaoPinManagement/zhaoPinsp')}           
          ]
        },
        {path: '/peiXunManagement', name: '培训管理', meta: {title: '培训管理'}, component: page('peiXunManagement/peiXunjh')},
        {path: '/kaoHeManagement', name: '考核管理', meta: {title: '考核管理'}, component: page('kaoHeManagement')},
        {path: '/jiFenManagement', name: '积分管理', meta: {title: '积分管理'}, component: page('jiFenManagement')},
        // 系统管理
        {path: '/timeTask', name: '定时任务', meta: {title: '定时任务'}, component: page('timeTask')},
        {path: '/systemLog', name: '系统日志', meta: {title: '系统日志'}, component: page('systemLog')},
        {path: '/smsNotice', name: '用户短信通知', meta: {title: '用户短信通知'}, component: page('smsNotice')},
        // {path: '/departManagement', name: '部门管理', meta: {title: '部门管理'}, component: page('departManagement')},
        {path: '/quanXianManagement', name: '权限管理', meta: {title: '权限管理'}, component: page('quanXianManagement')},
        {path: '/systemSetup', name: '系统设置', meta: {title: '系统设置'}, component: page('systemSetup')},
        {path: '/download', name: '客户端下载', meta: {title: '客户端下载'}, component: page('download')}
      ]
    },
    {path: '/login', name: 'login', component: page('login')},
    {path: '/500', name: '500', component: page('500')},
    {path: '*', name: '404', component: page('404')}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js